module.exports = __webpack_public_path__ + "img/B5.bd57e512.png";